import { Events } from '../events';
import { AuthHttp, JwtHelper, tokenNotExpired } from 'angular2-jwt';
import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams, Response } from '@angular/http'
import { Observable } from 'rxjs/Rx';
import { BaseService } from '../base.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class GenericService extends BaseService {

  states: Observable<any[]>
  private _states: BehaviorSubject<any[]>;
  private dataStore: {
    states: any[]
  };



  jwtHelper: JwtHelper = new JwtHelper();

  refreshSubscription: any;
  //  customer: CustomerModel = null;



  constructor(
    @Inject(Http) public http: Http,
    public authHttp: AuthHttp,
    public events: Events) {
    super();
    this.dataStore = { states: [] };
    this._states = <BehaviorSubject<any[]>>new BehaviorSubject([]);
    this.states = this._states.asObservable();
    this.getStates().subscribe(
      res => {
        this.dataStore.states = res;
        this._states.next(Object.assign({}, this.dataStore).states);
      }
    )
  }

  /**
* metodo que obtiene los estados del pais, dicho servicio sera utilizado para poblar el combo de perfil y tarjetas
* 
*/
  private getStates(): Observable<any> {

    return this.authHttp.get(this.urls.states).map(response => response.json())
      .catch(err => {
        return this.handleErrorAsObservable(err)
      });
  }

}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/components/generics.service.ts